var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-bar-chart-card',{attrs:{"title":"시설물 안전예산 집행률 현황","value":_vm.data,"total":_vm.total,"unit":"%","isMoveWrite":_vm.isMoveWrite,"is-move-detail":!!_vm.projectId,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }